import { SR_API_ACTION_LANDLORD_ASSING_TO_USER } from 'api/actionTypes';

export default async function assignToUser({ state, apiClient }, { landlordId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_LANDLORD_ASSING_TO_USER,
    state: state,
    payload: {
      landlordId,
    },
    onSuccess({ user }) {
      state.set('currentUser', user);
    },
  });
}
